import { createFileRoute } from '@tanstack/react-router';

import { BondingPaceStep } from '@/features/onboarding/components/steps/lf/bondingPaceStep';

export const Route = createFileRoute(
  '/_protected/onboarding/_steps/bonding-pace',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <BondingPaceStep />;
}
